document.addEventListener("DOMContentLoaded", function () {
  // const section = document.querySelector(".embedded-products-section");
  const sections = document.querySelectorAll(".embedded-products-section");

  sections.forEach(section => {
    
  
  const hotspots = section.querySelectorAll(".embedded-products-hotspot");
  const popupCloseButtons = section.querySelectorAll(".embedded-products-popup-close");

  let isPopupHovered = false; // Shared state

  hotspots.forEach((hotspot,hotspotInd) => {
    const hotspotId = hotspot.dataset.hotspotId;
    const popup = hotspot.closest('.embedded-products-grid-item').querySelector(`.embedded-products-popup[data-hotspot-id="${hotspotId}"]`);
    const gridItem = hotspot.closest('.embedded-products-grid-item');
    const gridItems = Array.from(gridItem.parentElement.children);
    const blockIndex = gridItems.indexOf(gridItem);

    if (popup) {
      hotspot.addEventListener("mouseenter", () => {
        isPopupHovered = true;
        showPopup(hotspot, popup, blockIndex, popup); // Pass blockIndex
      });

      hotspot.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!isPopupHovered) {
            hidePopup(popup);
          }
        }, 100); // Small delay to prevent flickering
      });

      popup.addEventListener("mouseenter", () => {
        // console.log('hotspotInd => ', hotspots[hotspotInd])
        isPopupHovered = true;
      });

      popup.addEventListener("mouseleave", () => {
        isPopupHovered = false;
        hidePopup(popup);
      });
    }
  });

  popupCloseButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.target.closest(".embedded-products-popup").style.display = "none";
    });
  });

  section.addEventListener("click", (event) => {
    if (event.target.classList.contains("embedded-products-popup")) {
      event.target.style.display = "none";
    }
  });

  function showPopup(hotspot, popup, blockIndex, element) {
    const hotspotRect = hotspot.getBoundingClientRect();
    const imageWrapperRect = hotspot.closest('.embedded-products-image-wrapper').getBoundingClientRect();

    let popupTop = hotspotRect.top - imageWrapperRect.top - popup.offsetHeight;
    let popupLeft;

    // if (blockIndex === 0) {
      // First block: Show on the right
      popupLeft = hotspotRect.left - imageWrapperRect.left;
    // } else if (blockIndex === 1) {
    //   // Second block: Show in the center
    //   popupLeft = hotspotRect.left - imageWrapperRect.left - popup.offsetWidth / 2;
    // } else if (blockIndex === 2) {
    //   // Third block: Show on the left
    //   popupLeft = hotspotRect.left - imageWrapperRect.left - popup.offsetWidth;
    // }

    popup.style.top = `${popupTop+180}px`;
    // popup.style.left = `${popupLeft}px`;
    popup.style.display = "block";

    // @@ If hotspot not in first image, then show modal to little left 
    if(parseInt(element.classList[1]) !== 1){
    popup.style.left = `${popupLeft - 180}px`;
    popup.style.top = `${popupTop+150}px`;
      
    }else{
    popup.style.left = `${popupLeft}px`;
    // popup.style.top = `${popupTop}px`;
      
    }
    
  }

  function hidePopup(popup) {
    popup.style.display = "none";
  }
  })
});
let popupHideTimeout = null;

hotspots.forEach((hotspot) => {
  const hotspotId = hotspot.dataset.hotspotId;
  const popup = hotspot.closest('.embedded-products-grid-item')
    .querySelector(`.embedded-products-popup[data-hotspot-id="${hotspotId}"]`);

  if (!popup) return;

  hotspot.addEventListener("mouseenter", () => {
    clearTimeout(popupHideTimeout);
    popup.style.display = "block"; 
  });

  hotspot.addEventListener("mouseout", (e) => {
    const to = e.relatedTarget;
    if (!hotspot.contains(to) && !popup.contains(to)) {
      popupHideTimeout = setTimeout(() => {
        popup.style.display = "none";
      }, 200);
    }
  });

  popup.addEventListener("mouseenter", () => {
    clearTimeout(popupHideTimeout);
  });

  popup.addEventListener("mouseout", (e) => {
    const to = e.relatedTarget;
    if (!popup.contains(to) && !hotspot.contains(to)) {
      popupHideTimeout = setTimeout(() => {
        popup.style.display = "none";
      }, 200);
    }
  });
});
